module.exports = __webpack_public_path__ + "assets/zepto.8b57bbea.svg";